import { API } from "config";
import request from "utilities/request";

const baseUrl = API.cortevaChain.url;

export async function deleteLegacyFolder(
  activeChatId: string,
  getAccessToken: () => Promise<string>
) {
  const accessToken = await getAccessToken();
  const url = `${baseUrl}/chat/deletefolder/?thread_id=${activeChatId}`;
  const method = "DELETE";

  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };
  const options = { method, headers };

  const response = await request(url, options);
  const responseJson = await response.json();
  return responseJson;
}
